import React, { useEffect, useRef, useState } from 'react';
import {
  Wrapper,
  HeaderWrapper,
  Span1,
  Span2,
  QueryPara,
  FlexWrapper,
  ChannelsText,
  TwitterText,
  StyledContainer,
  QueryPara2,
  TabHeading,
  Icon,
  DownloadWrapper,
  DateWrapper,
  CreateTopic,
} from './ViewReport.styled';
import html2pdf from 'html2pdf.js';

import { AmazonIconSmall, FlipkartIconSmall, FlipkartLogo, X_icon, download_icon } from '../../Common/SvgIcon/CommonSvgIcons';

import { useSelector, useDispatch } from 'react-redux';
import InsightsTab from './ChatterReport/InsightsTab';
import CommentsTab from '../ChatterTracker/MainComponent/ChatterPreview/CommentsTab/CommentsTab';
import ClusterAnalysisTab from './Download/ReportDownload/ClusterAnalysisTab';
import { formatDate } from '../../utils';
import GenerateAnalysis from '../../components/Generate Analysis/GenerateAnalysis';

import {
  fetchCreatedTopic,
  createNewTopic,
  activeTopicList,
} from '../../store/redux/slices/topicSlice';

import { getReport } from '../../store/redux/slices/sentinelHubSlice';

import { useNavigate } from 'react-router-dom';
import OverViewTab from './ChatterReport/OverviewTab';
import SentimentsTab from './ChatterReport/SentimentsTab';
import DownloadFile from './Download/Download';
import CustomAnalysisTab from './Download/ReportDownload/CustomAnalysisTab';



function convertDateTime(inputDateTime) {
  let dtObject = new Date(inputDateTime);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  let formattedDate =
    monthNames[dtObject.getMonth()] +
    ' ' +
    dtObject.getDate() +
    ' on ' +
    (dtObject.getHours() % 12 || 12) +
    ':' +
    (dtObject.getMinutes() < 10 ? '0' : '') +
    dtObject.getMinutes() +
    ' ' +
    (dtObject.getHours() >= 12 ? 'PM' : 'AM');

  return formattedDate;
}

const ViewReportsChatter = ({
  data,
  job_id,
  report_id,
  email_id,
  handleCancelClick,
  created_at,
  is_topic = true,
  hideDropdown,
  formatValue='dd-MM-yyyy',
  formattedDate=" ",formattedTime=" ",
}) => {
  const [AnalysisFilter, setAnalysisFilter] = useState('')
  const [activeTab, setActiveTab] = useState('overViewTab');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [download, setDownload] = useState(false);
  const contentDivRef = useRef(null);

  const [selectedReport, setSelectedReport] = useState(null)
  const { companyBasicDetailsData, teamMemberListData } = useSelector(
    (state) => state.tenantSetting
  );

  let { topicPreviewData } = useSelector((state) => state.topicBuilder) || {};
  // const topicPreviewData = data;
  //   const { created } = useSelector((state) => state.topicBuilder);

  let { getAllReportData } = useSelector((state) => state.sentinelHub) || [];

  let render_string = '{}';
  let outlook_report = {};

  if (getAllReportData.find((el) => el.email_id === email_id)) {
    let tempData = getAllReportData.find((el) => el.email_id === email_id);
    render_string = tempData?.render_field_string;
    outlook_report = tempData?.report;
  } 
  // else {
  //   dispatch(getReport(email_id));63
  // }

  let fetchedData;

  //   const hyperlink = selectedReport
  //     ? selectedReport?.hyperlink
  //     : previewData?.hyperlink;

  const selectedTopic = []

  if (typeof job_id === 'number' && selectedTopic !== undefined) {
    topicPreviewData = selectedTopic;
    fetchedData = selectedTopic?.data || getAllReportData?.[0]?.report;
  } else if (typeof email_id === 'string') {
    topicPreviewData = outlook_report;
  }
  fetchedData = topicPreviewData || getAllReportData?.[0]?.report;


  // useEffect(() => {
  //   if (typeof report_id === 'number') {
  //     dispatch(getReport(report_id)).then((data) => {
  //       setSelectedReport(data.payload.data);
  //     })
  //   }

  // }, [])

  useEffect(() => {
    if (getAllReportData?.length > 0 && getAllReportData?.[0]?.render_field_string) {
      try {
        const parsedFilter = JSON.parse(getAllReportData[0].render_field_string);
        setAnalysisFilter(parsedFilter);  // Set the parsed object to state
      } catch (error) {
        console.error('Failed to parse render_string:', error);
        setAnalysisFilter(null);
      }
    } else {
      console.warn('No valid render_string found');
      setAnalysisFilter(null);
    }
  }, [getAllReportData]);


  //   const overView_tab = fetchedData?.overview_tab || {};
  //   const sentiments_tab = fetchedData?.sentiments_tab || {};
  //   const insights_tab = fetchedData?.insights || {};
  //   const clusterAnalysis_tab = fetchedData?.cluster_analysis || {};

  //   const startDate =
  //     formatDate(overView_tab?.post_date?.start_date) || '2024/01/01';
  //   const endDate = formatDate(overView_tab?.post_date?.end_date) || '2024/01/02';

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overViewTab':
        return (
          <OverViewTab
            selectedReport={getAllReportData?.[0]?.report}
            chatterData={getAllReportData?.[0]?.report}
            plan={companyBasicDetailsData?.plan}
            hideDropdown={hideDropdown}
          /* chatterReport={report} */
          />
        );
      case 'sentimentsTab':
        return (
          <SentimentsTab
            selectedReport={getAllReportData?.[0]?.report}
            plan={companyBasicDetailsData?.plan}
            hideDropdown={hideDropdown}
          /* chatterReport={report} */
          />
        );
      case 'insightTab':
        return (
          <InsightsTab
            showTableView={getAllReportData?.[0]?.report?.channel == 'flipkart' ? true : false}
            insightTabData={getAllReportData?.[0]?.report}
            plan={companyBasicDetailsData?.plan}
            /* chatterReport={report} */
            selectedReport={getAllReportData?.[0]?.report}
            hideDropdown={hideDropdown}
          />
        );
      case 'clusterAnalysis':
        return (
          <ClusterAnalysisTab
            cluster_analysis={getAllReportData?.[0]?.report?.data?.cluster_analysis_tab}
            formatValue={formatValue}
            startDate={getAllReportData?.[0]?.report?.start_date}
            endDate={getAllReportData?.[0]?.report?.end_date}
            child={[
              {
                  "id": "4aa",
                  "name": "Sentiments",
                  "type": "checkbox",
                  "value": true,
                  "display": true
              },
              {
                  "id": "4ab",
                  "name": "Emotions",
                  "type": "checkbox",
                  "value": true,
                  "display": true
              }
          ]}
          />
          // <ClusterAnalysisTab
          //   data={getAllReportData?.[0]?.report?.data?.cluster_analysis_tab}
          //   selectedReport={getAllReportData?.[0]?.report?.data?.cluster_analysis_tab
          //   }
          //   startDate={getAllReportData?.[0]?.report?.start_date}
          //   endDate={getAllReportData?.[0]?.report?.end_date}
          //   moduleType={getAllReportData?.[0]?.report?.channel}
          // />
        );
      case 'customTab':
        return (
          <CustomAnalysisTab
            showCustom={false}
            AnalysisFilter={AnalysisFilter?.Custom_Analysis?.localVal}
            // formatValue={formatValue}
            // job_id={job_id}
            // preview_uuid={topicPreviewData?.preview_uuid}
          />
        );
      case 'commentsTab':
        return (<CommentsTab
          download={true}
          email_id={getAllReportData[0]?.email_id}
          channelName={getAllReportData?.[0]?.report?.channel}
          job_id={data?.job_id}
          hideDropdown={hideDropdown}
        />);
      default:
        return null;
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleGeneratePdf = (refsArray) => {
    setDownload(true)
    const element = document.getElementById('element-to-convert');


    setAnalysisFilter(getAllReportData?.length > 0 && JSON.parse(getAllReportData[0]?.render_field_string))


    const options = {
      filename: 'myfile.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
    };
    setTimeout(() => {


      // Call the html2pdf function with the selected element and options
      html2pdf().from(element).set(options).save()
        .then(() => {
          setDownload(false);
          handleCancelClick();
        })

    }, 3000); // 3000 milliseconds = 3 seconds

  }

      const { personalDetailsData } =
          useSelector((state) => state.tenantSetting) || {};
let col=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'rgba(45, 137, 85, 1)';
    
  return (
    <Wrapper>
      <HeaderWrapper>
        <Span1>{getAllReportData?.[0]?.report?.title || getAllReportData?.[0]?.report?.chatter_title}</Span1>
        <Span2>{getAllReportData?.[0]?.report?.description}</Span2>
        <StyledContainer>
          <ChannelsText>Channels:</ChannelsText>
          <TwitterText>
            <Icon>{getAllReportData?.[0]?.report?.category == 'topic' ? X_icon :
              getAllReportData?.[0]?.report?.channel == 'flipkart' ?
              FlipkartIconSmall :
                getAllReportData?.[0]?.report?.channel == 'amazon' ? AmazonIconSmall : ''}</Icon> &nbsp; {getAllReportData?.[0]?.report?.channel?.replace(/{|}/g, '')}
          </TwitterText>
        </StyledContainer>
        {
          getAllReportData?.[0]?.report?.category == 'topic' ?

            <QueryPara>
              <b>Query Used:&nbsp;</b> {getAllReportData?.[0]?.report?.keywords_string}

              <br />
            </QueryPara>

            :
            <b style={{ color: 'rgb(45, 137, 85)', wordBreak: 'break-all' ,cursor:'pointer',textDecoration:'underline'}}>{getAllReportData?.[0]?.report?.hyperlink}</b>

        }
        {/* <br /> lang: en since: 2023-01-01 until: 2023-05-18 geocode: 20.5937,78.9629,2000 km */}

      </HeaderWrapper>
      <DownloadWrapper>
        <div className='created_at'>
          {(is_topic == 'topic') ? 'Topic ' : 'Chatter '}
          Created at {formattedDate} {" "}{formattedTime}
        </div>

        <div className='buttonContainer'>
          <button className='button cancel' onClick={handleCancelClick}>
            Cancel
          </button>

          <button className='button'
          style={{background:col ? col : 'rgba(45, 137, 85, 1)'}}
            onClick={() => handleGeneratePdf(contentDivRef)}>
            {
              download ?
                '...downloading'
                :
                <>Download {download_icon}</>
            }

          </button>
        </div>
      </DownloadWrapper>
      <TabHeading col={col}>
        <div
          className={activeTab === 'overViewTab' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('overViewTab')}
        >
          Overviews
        </div>
        <div
          className={activeTab === 'sentimentsTab' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('sentimentsTab')}
        >
          Sentiments
        </div>
        <div
          className={activeTab === 'insightTab' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('insightTab')}
        >
          Insights
        </div>
        <div
          className={activeTab === 'clusterAnalysis' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('clusterAnalysis')}
        >
          Cluster Analysis
        </div>
        {/* <div
          className={activeTab === 'customTab' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('customTab')}
        >
          Custom Analysis
        </div> */}
        <div
          className={activeTab === 'commentsTab' ? 'activePlanTab' : ''}
          onClick={() => handleTabClick('commentsTab')}
        >
          Reviews
        </div>
      </TabHeading>
      {renderTabContent()}

      <div style={{ display: 'none' }}>
        <div ref={contentDivRef} id="element-to-convert">
          <DownloadFile
            AnalysisFilter={AnalysisFilter}
            email_id={data?.email_id + ''}
            created_at={data.creation_time}
            is_topic={data?.category}

            formatValue={formatValue}
            data={data}

          />
        </div>

      </div>

    </Wrapper>
  );
};

export default ViewReportsChatter;
